<template>
  <b-card>
    <pessoa-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :cabecalho="cabecalhoListagem"
      :info="info"
      :filtros="filtros"
      filtrar-por-ativo
    />
  </b-card>

</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comercial/pessoa/shared/services/api'

export default {
  name: 'PessoasVisualizacao',
  components: {
    PessoaList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'E-mail', field: 'email', editable: true },
      ],
      filtros: [{ colunas: ['Nome', 'Email'], valor: null }],
      cabecalhoListagem: { id: '', name: 'Nome' },
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getPessoas(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-pessoa' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-pessoa', params: { id: value.id } })
    },
    remover(itens) {
      if (itens && itens.length === 1) {
        return new Promise(resolve => {
          api.verificaVinculo(itens[0].id)
            .then(payload => {
              if (payload.data) {
                this.$swal({
                  text: 'Não é permitido realizar essa exclusão, pois este registro está associado em campos obrigatórios de outros cadastros. Deseja inativar?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Sim',
                  cancelButtonText: 'Não',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-danger ml-1',
                  },
                })
                  .then(result => {
                    if (result.value) {
                      api.deletePessoa(itens[0].id, true)
                        .then(() => {
                          resolve(true)
                        })
                    }
                  })
              } else {
                api.deletePessoa(itens[0].id, false)
                  .then(() => {
                    resolve(false)
                  })
              }
            })
        })
      }

      const idList = itens.map(map => map.id)
      return api.deleteAll({ identificadores: idList })
    },
  },
}
</script>
